// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@insite/mobius/FormField";
import { productActionsStyle } from "@vanmeter/App/Components/Product/ProductActions";
import { css } from "styled-components";

productActionsStyle.addToCartContainer = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
        gap: 8px;
        justify-content: space-between;
    `,
};

productActionsStyle.addToCartButtonWrapper = {
    css: css`
        flex-grow: 1;
    `,
};

productActionsStyle.productAddToCartButtonStyles = {
    sizeVariant: "small",
    css: css`
        width: 100%;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
};

productActionsStyle.unitOfMeasureSelect = {
    sizeVariant: "small",
    cssOverrides: {
        formField: css`
            margin-top: 0;
        `,
    },
    labelProps: {
        css: css`
            display: none;
            &&& + ${FormInputWrapper} {
                margin-top: 0;
            }
        `,
    },
};

productActionsStyle.multipleSaleQty = {
    css: css`
        width: 100%;
        &:has(> div:empty) {
            display: none;
        }
        > div {
            width: 100%;
        }
    `,
};

productActionsStyle.qtyWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productActionsStyle.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};
